
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bridge-wrap",
      function () {
        return require("private-next-pages/bridge-wrap.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bridge-wrap"])
      });
    }
  